import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'AAPILinks';

export const useAAPILinksStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  links: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
  },
  link: {
    borderBottom: `1px solid ${alpha(theme.palette.link.main, 0.5)}`,
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'none',
    },
  },
}));
